import { Injectable } from '@angular/core';
import {
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpInterceptor
} from '@angular/common/http';
import { Observable } from 'rxjs';

@Injectable()
export class AuthTokenInterceptorInterceptor implements HttpInterceptor {

  constructor() {}

  intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    const jwt = `eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJ1c2VyIjoiKzI1NDcxNzE3NDk4NSIsImlhdCI6MTY5NTIzODc3MX0.ET2uBIUH6GftXT--589g3S1_R013FiWTPFLQw50W5Q4`;
    const req = request.clone({
      setHeaders: { Authorization: 'Bearer ' + jwt },
    });
    return next.handle(req);
  }
}
